import * as yup from "yup";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { USER_ROLES } from "@constants/Roles";
import { UserTypeSelector } from "./user-type-selector";
import { MultipleOrganizationsSelector } from "@components/admin/common/multiple-organizations-selector";
import { OrganizationSearchSelector } from "@components/common/organization-search-selector";
import { InsightsPermission } from "./user-type-selector/utils/insights-permission";
export const UserFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object().shape({
        name: yup
            .string()
            .min(5, intl.formatMessage(messages.userNameLength))
            .required(intl.formatMessage(messages.userNameRequired)),
        phone: yup.string().matches(/\d{3}-\d{3}-\d{4}/, intl.formatMessage(messages.userNumberFormat)),
        email: yup
            .string()
            .email(intl.formatMessage(messages.userEmailInvalid))
            .required(intl.formatMessage(messages.userEmailRequired)),
        roleId: yup.string().required(intl.formatMessage(messages.userRoleRequired)),
        communities: yup.mixed().when("roleId", {
            is: USER_ROLES.Insights,
            then: yup.mixed().nullable().optional(),
            otherwise: yup
                .array()
                .of(yup.string())
                .min(1, intl.formatMessage(messages.userCommunityRequired))
                .required(intl.formatMessage(messages.userCommunityRequired)),
        }),
    });
};
export const CreateOrEditUserFormFields = ({ isAdminForm, isOwnerTypeForm, isInsightsTypeForm, }) => {
    const intl = useIntl();
    const organizationSelector = [
        {
            id: "organizations",
            label: intl.formatMessage(messages.userFormOrganization),
            placeholder: intl.formatMessage(messages.userFormOrganizationPlaceholder),
            required: true,
            columns: 12,
            component: isOwnerTypeForm ? MultipleOrganizationsSelector : OrganizationSearchSelector,
        },
    ];
    const insightPermissionSelector = [
        {
            id: "allow.insights",
            label: intl.formatMessage(messages.editUserAction),
            placeholder: "",
            required: false,
            component: InsightsPermission,
            columns: 12,
        },
    ];
    return {
        createUser_row1: {
            userDetails: [
                {
                    id: "name",
                    label: intl.formatMessage(messages.userFormName),
                    placeholder: intl.formatMessage(messages.userFormName),
                    required: true,
                    columns: 7,
                },
                {
                    id: "phone",
                    label: intl.formatMessage(messages.userFormPhone),
                    placeholder: intl.formatMessage(messages.userFormPhonePlaceholder),
                    required: true,
                    columns: 5,
                },
                {
                    id: "email",
                    label: intl.formatMessage(messages.userFormEmail),
                    placeholder: intl.formatMessage(messages.userFormEmailPlaceholder),
                    required: true,
                    columns: 12,
                },
            ],
        },
        createUser_row2: {
            insightPermissionDetails: [...((isAdminForm && [...insightPermissionSelector]) || [])],
        },
        createUser_row3: {
            roleDetails: [
                ...((isAdminForm && !isInsightsTypeForm && [...organizationSelector]) || []),
                {
                    id: "roleId",
                    label: intl.formatMessage(messages.userRole),
                    placeholder: "",
                    rolesOptions: [
                        isAdminForm && USER_ROLES.Insights,
                        USER_ROLES.Basic,
                        USER_ROLES.Agent,
                        isAdminForm && USER_ROLES.Scanner,
                        isAdminForm && USER_ROLES.Owner,
                        USER_ROLES.OrgAdmin,
                    ],
                    required: false,
                    component: UserTypeSelector,
                    columns: 12,
                },
            ],
        },
    };
};
